import React, { useEffect, useRef } from "react";
import { classNames } from "maven-lib/dist/utils/misc";

interface HbTextProps {
  className?: string;
  multiline?: boolean;
  placeholder?: string;
  defaultVal?: string | number | null | undefined;
  isTextFocusOn?: boolean;
  onValueChange: (value: number | string | null, ev?: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onClickEvent?: (ev: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement, MouseEvent>) => void;
  disabled?: boolean;
  prefix?: string;
  suffix?: string;
}

export function HbText(props: HbTextProps) {
  const { className, multiline, placeholder, onValueChange, onClickEvent, isTextFocusOn: isTextOnFocus, defaultVal, disabled, prefix, suffix } = props;
  const typeTextInputFocus = useRef(null);

  useEffect(() => {
    if (isTextOnFocus) {
      typeTextInputFocus.current.focus();
    }
  }, [isTextOnFocus]);

  const hbTextClassNames: Array<string> = [];

  if (prefix) hbTextClassNames.push("--with-prefix");
  if (suffix) hbTextClassNames.push("--with-suffix");

  return (
    <div className={classNames("hb-text", className, hbTextClassNames)}>
      {!!prefix && (<div className={classNames("hb-text-affix", "--prefix")}>
        <span>{prefix}</span>
      </div>)}
      {!multiline && (
        <input
        ref={typeTextInputFocus}
        className="hb-text-input"
        disabled={disabled}
        value={defaultVal || ""}
        placeholder={placeholder}
        onClick={(ev) => onClickEvent && onClickEvent(ev)}
        onChange={(ev) => onValueChange(ev.currentTarget.value, ev)}
        />
        )}
      {multiline && (
        <textarea
        className="hb-text-area"
        disabled={disabled}
        value={defaultVal || ""}
        placeholder={placeholder}
        onClick={(ev) => onClickEvent && onClickEvent(ev)}
          onChange={(ev) => onValueChange(ev.currentTarget.value, ev)}
          />
          )}
      {!!suffix && (<div className={classNames("hb-text-affix", "--suffix")}>
        <span>{suffix}</span>
      </div>)}
    </div>
  );
}
